import { type AxiosInstance } from 'axios'

interface CreateData {
  email: string
  password: string
  company: number
}
interface SendData {
  email: string
  company: number
  password: string
}

export default (axios: AxiosInstance) => ({
  listAll(companyId: number) {
    return axios.get(`/v1/invitations/companies/${companyId}/`)
  },
  createAndSend(data: CreateData) {
    return axios.post('/v1/invitations/create-and-send/', data)
  },
  send(id: number, data: SendData) {
    return axios.post(`/v1/invitations/${id}/send/`, data)
  },
  delete(id: number) {
    return axios.delete(`/v1/invitations/${id}/`)
  },
  getInvitations() {
    return axios.get(`/v1/invitations/`)
  },

  acceptInvite(key: string) {
    return axios.post(`/v1/invitations/accept-invite/${key}`)
  },
})
